import * as React from 'react'
import { Modal, Button, Alert } from 'react-bootstrap'
import InscriptionModal from './InscriptionModal'
import ConnexionModal from './ConnexionModal'
import PasswordModal from './PasswordModal'
import ApiCall from '../../../../components/ApiCall/ApiCall'
//import { LaptopWindows } from '@material-ui/icons'
require('../../../Accueil/header.css')
/*
    This class take care of the button sign in and sign up and launch the script of the respective pop-up pages
*/
type ViewConnectionOption = 'Connexion' | 'Inscription' | 'Envoyer'

interface LoginProps {
}

interface LoginState {
    show: boolean,
    view: ViewConnectionOption,
    email: string,
    password: string,
    passwordVerify: string,
    error: boolean,
    message: string,
    alert: boolean,
    alert_message: string
}

export default class LoginButton extends React.Component<LoginProps, LoginState> {

    private api = new ApiCall()

    constructor(props: LoginProps) {
        super(props)
        this.state = {
            show: false,
            view: 'Connexion',
            email: "",
            password: "",
            passwordVerify: "",
            error: false,
            message: "",
            alert: false,
            alert_message: ""
        }
    }

    writeError() {
        let { error, message } = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger">
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
    }

    render() {
        let { show, view } = this.state
        return (
            <>
                <div id="log2">
                    <Button id="Inscription" variant="primary" onClick={this.SetViewInscription}>
                        S'inscrire
                    </Button>
                </div>
                <div id="log1">
                    <Button id="ButtonLogin" variant="primary" onClick={this.SetViewConnexion}>
                        Connexion
                    </Button>
                </div>

                <Modal show={show} onHide={this.handleClose}>

                    <Modal.Header closeButton>
                        <Modal.Title>{view}</Modal.Title>
                    </Modal.Header>
                    {this.writeError()}
                    {view === "Inscription" && <InscriptionModal
                        ChangeViewToConnexion={this.SetViewConnexion}
                        ChangeViewToPasswordForgot={this.SetViewPasswordForgot}
                        updateEmail={this.updateEmail}
                        updatePassword={this.updatePassword}
                        updatePasswordVerify={this.updatePasswordVerify}
                    />}

                    {view === "Connexion" && <ConnexionModal
                        ChangeViewToInscription={this.SetViewInscription}
                        ChangeViewToPasswordForgot={this.SetViewPasswordForgot}
                        updateEmail={this.updateEmail}
                        updatePassword={this.updatePassword}
                    />}

                    {view === "Envoyer" && <PasswordModal
                        ChangeViewToInscription={this.SetViewInscription}
                        ChangeViewToConnexion={this.SetViewConnexion}
                        updateEmail={this.updateEmail}
                    />}

                    <Modal.Footer>
                        <Button id="modal_connexion" variant="success" onClick={this.SubmitForm}>
                            {view}
                        </Button>
                        <Button id="modal_close" variant="danger" onClick={this.handleClose}>
                            Fermer
                        </Button>
                    </Modal.Footer>

                </Modal>
            </>
        );
    }

    handleShow = () => this.changeStateView(true);
    handleClose = () => {
        this.setState({
            error: false,
            message: ""
        })
        this.changeStateView(false)
    }

    SbmitInscription = async () => {
        let { email, password, passwordVerify } = this.state

        if (password !== passwordVerify) {
            this.setState({
                error: true,
                message: "Merci de remplir deux fois le même mot de passe!"
            })
            return
        }
        if (email === "" || password === "") {
            this.setState({
                error: true,
                message: "Merci de remplir un email et un mot de passe!"
            })
            return
        }
        const request = await this.api.ApiCall("Users", "POST",
        {
            email: email,
            password: password
        })
        console.log(request.data);
        if (request.status === 201) {
            this.setState({
                error: false,
                message: "Votre inscription a bien été prise en compte. Vous recevrez un e-mail de confirmation."
            })
        } else {
            this.setState({
                error: true,
                message: request.data.detail
            })
        }
    }

    SbmitConnexion = async () => {
        let { email, password } = this.state

        if (email === "" || password === "") {
            this.setState({
                error: true,
                message: "Merci de remplir un email et un mot de passe!"
            })
            return
        }
        const request = await this.api.ApiCall("login", "POST",
            {
                email: email,
                password: password
            })
        if (request.status === 200) {
            localStorage.setItem('AccessToken', request.data.accessToken);
            this.setState({
                error: false,
                message: "Vous êtes bien connecté."   
            })
            window.location.reload();
        } else if (request.status === 401) {
            this.setState({
                error: true,
                message: request.data.detail
            })
        }  else if (request.status === 400) {
            this.setState({
                error: true,
                message: request.data.detail
            })
        } else if (request.status === 404) {
            this.setState({
                error: true,
                message: request.data.detail
            })
        }else {
            this.setState({
                error: true,
                message: request.data.detail
            })
        }
    }

    SbmitPassword = async () => {
        let { email } = this.state

        if (email === "") {
            this.setState({
                error: true,
                message: "Merci de remplir un email et un mot de passe!"
            })
            return
        }
        const request = await this.api.ApiCall("passwords/newPassword/"+email, "GET",
            {
            })
        if (request.status === 200) {
            this.setState({
                error: false,
                message: request.data.message
            })
        } else if (request.status === 401) {
            this.setState({
                error: true,
                message: request.data.message
            })
        } else {
            this.setState({
                error: true,
                message: request.data.message
            })
        }
    }

    SubmitForm = () => {
        let { view } = this.state

        if (view === 'Inscription') {
            this.SbmitInscription()
        } else if (view === 'Connexion') {
            this.SbmitConnexion()
        } else if(view === 'Envoyer') {
            this.SbmitPassword()
        }
    }

    changeStateView = (showValue: boolean) => this.setState({ show: showValue })

    changeView = (NewView: ViewConnectionOption) => {
        this.setState({ view: NewView, email: "", password: "", passwordVerify: "", show:true })
    }

    SetViewConnexion = () => {
        this.changeView("Connexion")
    }

    SetViewInscription = () => {
        this.changeView("Inscription")
    }

    SetViewPasswordForgot = () => {
        this.changeView("Envoyer")
    }

    updateEmail = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ email: (e.target as HTMLInputElement).value })
    }

    updatePassword = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ password: (e.target as HTMLInputElement).value })
    }

    updatePasswordVerify = (e: React.FormEvent<HTMLInputElement>) => {
        this.setState({ passwordVerify: (e.target as HTMLInputElement).value })
    }

}
